export default { sha: 'd96727eed89d6ad44f1b00d9b333f717135d2b30', buildNumber: 'undefined' }
